module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEVHcEwc07kc1Lgd07gc07gb07gc07kUyq0c07gb0rcZ0rgc07gc07cc1Lgc07ga0rUe1bgc07gqr1Z1AAAAEXRSTlMAhafd81drB7lFIczgl9cnK6lAxDYAAAB3SURBVBjTbY/bDsMwCENJQgIkTTv//8+uudBK03gxHFm2ICLKyki90h5RIDUG5w0Uet24MGzeGSpzMRyyDJ9tjcvCycMywhA0B7ZAYtmgoAzpS+6eE9fQyjyzJCJ6Fnq2csL7yQ6MifoQsRBKHT84eb/6Q+iHtC91FgR5LztkMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_search.png
// module id = 3xrr
// module chunks = 2